import { useShortFromPropsOrParams, mapShortProfessorToProfessor } from '..';
import InstructorList from '../../../components/InstructorList';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentInstructors = props => {
  const {
    short
  } = useShortFromPropsOrParams(props);
  if (!short) return null;
  const {
    contentId: shortId,
    professors,
    language
  } = short;
  const trackProfessorClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'SHORTFORM',
      appearsIn: 'short-form-content',
      organisation,
      organisationUrl,
      professorId,
      shortId
    });
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: trackProfessorClick,
      language: language,
      professors: professors.map(mapShortProfessorToProfessor(language))
    })
  });
};
export default ShortContentInstructors;